export {default as Timetable} from './components/Timetable.jsx';



// WEBPACK FOOTER //
// ./js/sport-betting/components/Timetable/index.js